import { useCallback } from "react";
import { CourtGridTimeSlot } from "../../../models/CourtGridData";
import { SlotStatus } from "../../shared/TimeSlot";

interface UseWeeklySlotStatusProps {
  exercisesInBasket: number[];
}

export default function useWeeklySlotStatus({ exercisesInBasket }: UseWeeklySlotStatusProps) {
  // Sprawdza czy slot minął na podstawie jego daty i godziny
  const isSlotPast = useCallback((slotDate: string, timeString: string) => {
    const now = new Date();
    const [hours, minutes] = timeString.split(":").map(Number);
    
    // Parsuj datę slotu i ustaw godzinę
    const slotDateTime = new Date(slotDate);
    slotDateTime.setHours(hours, minutes, 0, 0);
    
    // Slot minął jeśli jego data+godzina jest wcześniejsza niż teraz
    return slotDateTime.getTime() <= now.getTime();
  }, []);

  const getSlotStatus = useCallback(
    (timeSlot: CourtGridTimeSlot, slotDate: string): SlotStatus => {
      // Sprawdź czy slot minął (na podstawie konkretnej daty slotu)
      if (isSlotPast(slotDate, timeSlot.startTime)) {
        return "unavailable";
      }

      if (timeSlot.userAssigned) {
        return "assigned";
      }

      if (exercisesInBasket.includes(timeSlot.exerciseId)) {
        return "in-basket";
      }

      if (timeSlot.reserved >= timeSlot.capacity) {
        return "sold-out";
      }

      return "available";
    },
    [exercisesInBasket, isSlotPast]
  );

  return {
    getSlotStatus,
    isSlotPast,
  };
}

